import { render } from "./AmiSéminaire.vue?vue&type=template&id=4ed7bee4&scoped=true&ts=true"
import script from "./AmiSéminaire.vue?vue&type=script&lang=ts"
export * from "./AmiSéminaire.vue?vue&type=script&lang=ts"

import "./AmiSéminaire.vue?vue&type=style&index=0&id=4ed7bee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed7bee4"]])

export default __exports__